import * as ngCore from '@angular/core'
import * as ents from '@attain-apps/entities'
import * as ds from '@attain-apps/fe/web/main/lib/design'

import * as state from '../../../../../../../state'
import * as componentStore from '../component-store'

import * as chart from './chart'

/**
 * Modal used to deploy Quiver resources
 */
@ngCore.Component({
  imports: [
    chart.Component,
    ds.tabs.integratedHorizontal.Component,
    ds.tabs.tab.Directive,
  ],
  selector: 'atn-widget-tree-editor',
  standalone: true,
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {
  /** @see {@link componentStore.Widget} */
  public readonly widgetStore = ngCore.inject(
    componentStore.Widget<ents.core.mosaic.Widget.Type.TreeEditor>,
  )
  /** @see {@link state.mosaic.treeEditor.Feature} */
  public readonly treeEditorFeature = ngCore.inject(
    state.mosaic.treeEditor.Feature,
  )

  /**
   * Effect that responds to widget content changes by initializing the tree editor.
   * Monitors the widget reference ID and content, updates the store state with the
   * chart ID, and dispatches initialization actions when tree data is available.
   */
  private readonly _initTreeEditor = ngCore.effect(() => {
    const widgetRefId = this.widgetStore.refIdSg()
    ngCore.untracked(() => {
      const tree = this.widgetStore.contentSg()
      if (tree) {
        this.treeEditorFeature.actions.init
          .from('TreeEditorComponent.Init')
          .dispatch({ tree, widgetRefId })
      }
    })
  })

  /** TODO:  */
  public chartIdsSg = ngCore.computed(
    (widgetRefId = this.widgetStore.refIdSg()) => ({
      current: state.mosaic.treeEditor.models.Chart.Id.from(widgetRefId),
      proposed: state.mosaic.treeEditor.models.Chart.Id.from({
        entry: 'proposed',
        widgetRefId,
      }),
    }),
  )
}
